import { Dialog, useDialogManager } from '../components/widgets/dialog';
import { PrimaryButton } from '../components/widgets/buttons';
import React, { FC } from 'react';
import { CenteredButtonContainer, DescriptionContent, IFrameContainer } from './connectDialogStyle';
import { T } from './helpers';
import ShopwiredConnectShop from './svg/shopwiredConnectShop';

export const ZendeskShopDialog: FC<{
    platform: string;
    title?: string;
    titleHtml?: React.ReactNode;
    className?: string;
    windowDecorator?: FC<any> | undefined;
    size?: 'small' | 'medium' | 'large' | 'xlarge' | 'fullscreen';
}> = (props) => {
    const { closeDialog } = useDialogManager();
    const Close = () => {
        closeDialog('zendesk-connect');
    };

    const handleGuide = () => {
        switch (props.platform) {
            case 'SHOPWIRED':
                window.open('https://help.shopwired.co.uk/manual/product-enhancements/zakeke', '_blank');
                break;
            default:
                break;
        }
    };

    return (
        <Dialog title={props.title} titleHtml={props.titleHtml} onClose={Close} windowDecorator={props.windowDecorator} size={props.size}>
            <IFrameContainer>{props.platform === 'SHOPWIRED' && <ShopwiredConnectShop />}</IFrameContainer>
            <DescriptionContent>
                {props.platform === 'SHOPWIRED' &&
                    T._(
                        `This integration is managed directly by the ShopWired team. For step-by-step instructions to set it up, click below to access their guide and get started.`,
                        'Admin'
                    )}
            </DescriptionContent>
            <CenteredButtonContainer>
                <PrimaryButton onClick={handleGuide}>{T._('Read full guide here', 'Admin')}</PrimaryButton>
            </CenteredButtonContainer>
        </Dialog>
    );
};
